import './public-path'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import Antd from 'ant-design-vue'
import App from './App.vue'
import routes from './routes'
import store from './store'
import '@/assets/css/reset.css'
import '@cbim/design-system-antd-adapter/vue.less'
import '@cbim/design-system-variable/index.css'
import { mircoAcp } from './utils/const'
import utilsTools from './utils/utilsTools'
import i18n from './utils/i18n'

/** CBIM基础图标库 */
// 在线引入
import '@/assets/css/iconfont.css'
// 本地引入
// import '@/assets/css/iconfont/iconfont.css'

let instance: any = null
let router = null

function render (props: mountProps = { container: '', registry: { activeRule: '' } }) {
  const { container, registry } = props
  const { __CBIM_PLATFORM_APPLICATION_BOOT_DATA__ } = window as any
  const baseURL = registry ? (registry?.activeRule || __CBIM_PLATFORM_APPLICATION_BOOT_DATA__?.appRouter || '') : ''

  router = createRouter({
    history: createWebHistory(baseURL || process.env.BASE_URL),
    routes
  })

  router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta?.title && typeof (to.meta?.title) === 'string') {
      document.title = to.meta?.title
    } else {
      document.title = 'CBIM协同平台'
    }
    if (to.meta.icon && typeof (to.meta?.icon) === 'string') {
        document.getElementsByTagName('link')[0].setAttribute('href',`${baseURL}${to.meta?.icon}`)
    }
    next()
  })

  console.log('[app will render]:', props)
  instance = createApp(App)
  instance
    .use(i18n)
    .use(utilsTools)
    .use(store)
    .use(router)
    .use(Antd)
    .mount(container ? (container as any).querySelector('#application-name') : '#application-name')
}

export async function bootstrap () {
  console.log('[app is bootstraped]')
}

export async function mount (props: mountProps) {
  console.log('[app is mounted]')
  const {
    globalStore,
    // user,
    startMicroCbimAcp
  } = props

  // 全局状态库
  // store.dispatch('commonStore/setUserInfo', user)

  // 主应用传递的数据监听
  globalStore.onGlobalStoreChange(([data]: Array<any>) => {
    console.log('setWorkspace:', data)
    store.dispatch('commonStore/setWorkspace', data?.workspace)
  }, true)

  // eslint-disable-next-line no-multi-assign
  mircoAcp.acp = startMicroCbimAcp('') // 主应用上挂载的可调用的方法

  // // eslint-disable-next-line no-multi-assign
  mircoAcp._originProps = props

  render(props)
  return Promise.resolve()
}

export async function unmount () {
  console.log('[app is unmounted]')
  // 应用卸载
  instance.unmount()
  instance = null
  router = null
}

// 独立运行时，直接挂载应用
if (!(window as any).__POWERED_BY_QIANKUN__) {
  render()
}
